import { render, staticRenderFns } from "./TeamBanner.vue?vue&type=template&id=b2aabb26&scoped=true&"
import script from "./TeamBanner.vue?vue&type=script&lang=js&"
export * from "./TeamBanner.vue?vue&type=script&lang=js&"
import style0 from "./TeamBanner.vue?vue&type=style&index=0&id=b2aabb26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2aabb26",
  null
  
)

export default component.exports